module.exports = __webpack_public_path__ + "old3.jpg?67ed102244285bd9bac71bf38e8c760e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old3.jpg
// module id = 81
// module chunks = 0